module.exports = __webpack_public_path__ + "static/media/SignOutHover.004dfa38.svg";